export default __webpack_public_path__ + "static/images/cart-white-c887442b93bf03eb2e0902483f233f88.png";